import { createContext, useState, useEffect, ReactNode } from 'react'
import { companiesAPI } from '../services/api'
import { useAuth } from '../hooks/useAuth'
import type { Company } from '../types'

interface CompanyContextType {
  company: Company | null
  loading: boolean
  refresh: () => Promise<void>
}

export const CompanyContext = createContext<CompanyContextType>({
  company: null,
  loading: true,
  refresh: async () => {},
})

export function CompanyProvider({ children }: { children: ReactNode }) {
  const { isAuthenticated } = useAuth()
  const [company, setCompany] = useState<Company | null>(null)
  const [loading, setLoading] = useState(true)

  const fetchCompany = async () => {
    if (!isAuthenticated) {
      setLoading(false)
      return
    }
    try {
      const resp = await companiesAPI.current()
      setCompany(resp.data)
    } catch {
      // Company might not be synced yet
    } finally {
      setLoading(false)
    }
  }

  useEffect(() => {
    fetchCompany()
  }, [isAuthenticated])

  return (
    <CompanyContext.Provider value={{ company, loading, refresh: fetchCompany }}>
      {children}
    </CompanyContext.Provider>
  )
}
